import script from "./EnglishPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EnglishPage.vue?vue&type=script&setup=true&lang=js"

import "./EnglishPage.vue?vue&type=style&index=0&id=120a7da6&lang=scss"

const __exports__ = script;

export default __exports__